import {
  CLEAR_SALESFORCE_DETAILS,
  SET_SALESFORCE_DETAILS,
} from 'state/booking/constants'
import {
  initialGlobalValue,
  SET_BOOKING_ATTRIBUTION,
  UPDATE_GROUPED_FILTERS,
} from './constants'

export const globalReducer = (
  state = initialGlobalValue,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): GlobalReducerType => {
  switch (action.type) {
    case UPDATE_GROUPED_FILTERS:
      return {
        ...state,
        globalGroupedFilters: action.payload,
      }
    case SET_SALESFORCE_DETAILS:
      return {
        ...state,
        salesforceDetails: action.payload,
      }
    case CLEAR_SALESFORCE_DETAILS:
      return {
        ...state,
        salesforceDetails: {},
      }
    case SET_BOOKING_ATTRIBUTION:
      return {
        ...state,
        bookingAttribution: action.payload,
      }
    default:
      return state
  }
}
